import { create } from "zustand";
import { persist } from "zustand/middleware";
import { DELAY_FORM_PERSIST_KEY } from "../constants";

/** The delay (or the new delay) a stored draft belongs to; `delayId` is null for Add. */
export interface DelayDraftTarget {
  operationId: string;
  delayId: string | null;
}

interface DelayFormState {
  target: DelayDraftTarget | null;
  values: Record<string, unknown>;
  setDraft: (target: DelayDraftTarget, values: Record<string, unknown>) => void;
  reset: () => void;
}

/** DBCO-0059 (L4) - the drawer's draft, kept per operation and per delay so a refresh does not lose what was typed. */
export const useDelayFormStore = create<DelayFormState>()(
  persist(
    (set) => ({
      target: null,
      values: {},
      setDraft: (target, values) => set({ target, values }),
      reset: () => set({ target: null, values: {} }),
    }),
    { name: DELAY_FORM_PERSIST_KEY },
  ),
);
